var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"float-left"},[_c('span',{staticClass:"text-sm leading-6 mr-3",class:_vm.isQueen?'text-yellow-500':'text-red-500'},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.onClicked(_vm.c,$event)}}},[_vm._v("#"+_vm._s(_vm.c.n))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }